module.exports = __webpack_public_path__ + "static/img/Boss_31007.387ca341.png";